import AccountPage from '../views/Account.vue';
import AccountContainer from '../views/AccountContainer.vue';
import CreditsRecord from '../views/CreditsRecord.vue';
import ClientCreditsRecord from '../views/ClientCreditsRecord.vue';

export default [
  {
    path: '/account',
    name: 'account',
    component: AccountPage,
    meta: { requiresAuth: true, title: 'account', action: 'views.clientConfig.read' },
    redirect: { name: 'account-data' },
    children: [
      {
        path: 'account-data',
        name: 'account-data',
        component: AccountContainer,
        meta: { title: 'accountData', hideBreadcrumb: true }
      },
      {
        path: 'credits-record',
        name: 'client-credits-record',
        component: ClientCreditsRecord,
        meta: { title: 'creditsRecord', action: 'components.plan.credits.edit.seeRecords' }
      },
      {
        path: 'credits-record',
        name: 'credits-record',
        component: CreditsRecord,
        meta: { title: 'manageCredits', action: 'components.plan.credits.edit.manageCredits' }
      },
      {
        path: 'subscription-record',
        name: 'subscription-record',
        component: CreditsRecord,
        meta: {
          title: 'manageSubscription',
          action: 'components.plan.subscription.edit.manageSubscription'
        }
      }
    ]
  }
];
